import { signOut } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import PostPreview from '../../components/blog/preview';
import { ButtonLink } from '../../components/common/button';
import { Confirm } from '../../components/common/confirmation';
import List from '../../components/common/list';
import { ToastContext } from '../../components/toast/toast-context';
import { executeGQL, search } from '../../lib/api';
import { useTranslation } from '../../lib/i18n';
import { clear } from '../../lib/storage';

const ConfirmDeletePage = ({ questions }) => {
  const { t } = useTranslation();
  const { toast } = useContext(ToastContext);
  const router = useRouter();

  return (
    <Confirm
      heading={t('accountDeleteHeading')}
      loginDescription={t('accountDeleteLoginDescription')}
      action={async () => {
        const { hasErrors } = await executeGQL('accountDelete', {
          token: router.query.token,
        });
        if (hasErrors) {
          toast.show(t('errorWhileSaving'), {
            type: 'error',
            timeout: 0,
          });
        } else {
          toast.show(t('accountDeleted'), { keepAlive: true });
          clear();
          signOut({ redirect: false });
          return router.push('/');
        }
      }}
      buttonLabel={t('accountDeleteButton')}
    >
      <>
        <h2 className='mt-24'>{t('homeQuestions')}</h2>
        <List
          component={PostPreview}
          className='mt-10'
          items={questions}
          listName='delete page'
        />
        <ButtonLink className='mt-12 max-w-md' href='/blog?filter=tags--Fragen'>
          {t('homeQuestionsButton')}
        </ButtonLink>
      </>
    </Confirm>
  );
};

export async function getStaticProps() {
  const questions = (
    await search(`filter=type--blog||tags--Fragen&sort=published--desc&size=3`)
  ).results;

  return {
    props: {
      questions,
    },
  };
}

export default ConfirmDeletePage;
